import React from 'react';
import Button from "react-bootstrap/Button";
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";

const TrainingsTiers = () => {

     const navigate = useNavigate(); // Initialize navigate
    
      const handleClick = () => {
        navigate("/courses"); // This will navigate to the "/another-page" route
      };

        const handleClick1 = () => {
        navigate("/tiers"); // This will navigate to the "/another-page" route
      };




  const features = [
    {
      feature: "Focus",
      course: "Specific skill or topic (e.g., coding, robotics, AI, 3D modelling, app development)",
      tier: "Holistic, multi-week engagement (homework support, tech, leadership, enrichment, entrepreneurship)",
    },
    {
      feature: "Commitment",
      course: "One-time or short-term",
      tier: "Monthly subscription / ongoing",
    },
    {
      feature: "Audience",
      course: "Students or learners looking for a particular course",
      tier: "Students seeking structured support, skill-building, and leadership opportunities",
    },
    {
      feature: "Experience",
      course: "Focused learning",
      tier: "Homework help + tech + creative projects + leadership track",
    },
    {
      feature: "Pricing",
      course: "Per course/session",
      tier: "Tiered monthly pricing",
    },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 pt-32 sm:pt-40 pb-10"> {/* increased top padding */}
      <h1 className="text-3xl font-bold text-center mb-6">Single Trainings vs Tiered Plans</h1>
      
      {/* Descriptive Section */}
      <div className="bg-gray-50 p-6 rounded-lg mb-6">
        <h2 className="text-xl font-semibold mb-3">Choose the right training and learning path:</h2>
        <p className="mb-2"><strong>Single Trainings:</strong> Select individual courses or skill-focused trainings tailored to your interests.</p>
        <p className="mb-4"><strong>Tiered Plans:</strong> Engage in a structured, ongoing program that combines homework support, tech skills, creative projects, and leadership opportunities.</p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">         
             <Button onClick={handleClick}>See Single Trainings</Button>
           <Button onClick={handleClick1}>See Tiered Plans</Button>
        </div>
      </div>

      {/* Animated Comparison Table */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="overflow-x-auto"
      >
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-6 py-3 text-left font-semibold">Feature</th>
              <th className="border px-6 py-3 text-left font-semibold">Single Course Trainings</th>
              <th className="border px-6 py-3 text-left font-semibold">Tiered Enrichment Plans</th>
            </tr>
          </thead>
          <tbody>
            {features.map((item, index) => (
              <motion.tr
                key={index}
                className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <td className="border px-6 py-4 font-medium">{item.feature}</td>
                <td className="border px-6 py-4">{item.course}</td>
                <td className="border px-6 py-4">{item.tier}</td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </motion.div>
    </div>
  );
};

export default TrainingsTiers;
